import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
const painPoints = [{
  emoji: '📱',
  bold: 'Ves mesas de resina en Instagram',
  text: <>
        y pensás <em className="text-gray-500" data-id="element-174">"yo quiero hacer eso"</em> — pero{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-175">
          no sabés por dónde empezar
        </span>
        .
      </>
}, {
  emoji: '🫧',
  bold: 'Compraste resina, seguiste un tutorial',
  text: <>
        y quedó{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-176">llena de burbujas</span>.{' '}
        <span className="underline-red" data-id="element-177">
          Tiraste miles de pesos sin saber qué hiciste mal.
        </span>
      </>
}, {
  emoji: '🌍',
  bold: 'Buscás tutoriales y todos son de afuera.',
  text: <>
        Los materiales{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-178">no existen en Uruguay</span>{' '}
        y los precios no tienen nada que ver.
      </>
}, {
  emoji: '🪞',
  bold: 'Hacés la mesa y queda bien,',
  text: <>
        pero no tiene ese{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-179">brillo espejo</span> que ves
        en las fotos. Y sin ese brillo no podés cobrar lo que vale.
      </>
}, {
  emoji: '💸',
  bold: 'Vendiste una mesa y después te diste cuenta',
  text: <>
        de que trabajaste horas para{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-180">ganar casi nada</span> porque
        no sabías cómo calcular el precio.
      </>
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function PainPointsSection() {
  return <section className="py-[40px] md:py-[64px] px-5 bg-[#F9FAFB] relative" data-id="element-181">
      <div className="max-w-3xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-[20px]" data-id="element-183">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-[10px] flex items-center justify-center gap-4" data-id="element-184">
            <AlertTriangleIcon className="w-8 h-8 text-[#DC2626]" data-id="element-185" />
            ¿TE PASA ESTO?
          </h2>
          <div className="w-24 h-1 bg-[#DC2626]/30 mx-auto mt-[10px]" data-id="element-186"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-[12px]" data-id="element-187">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="card-light border-l-[5px] border-l-[#DC2626] px-[20px] py-[20px] hover:border-l-[#EF4444] hover:translate-x-[4px] transition-all duration-300 flex gap-4 items-start" data-id="element-188">
              <span className="text-3xl shrink-0 mt-1" data-id="element-189">{point.emoji}</span>
              <p className="text-body-main text-gray-700 leading-relaxed" data-id="element-190">
                <strong className="font-bold text-[#B91C1C] block mb-1" data-id="element-191">
                  {point.bold}
                </strong>
                {point.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}